const apiRoleConfig = {
  name: 'API Role',
  endpoint: '/internal_admin/admin_kit/api_roles',
  modelKey: 'rbac_api_role',

  columns: [
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'description', title: 'Description' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[description_cont]', label: 'Description' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  panels: [
    {
      title: 'Permissions',
      endpoint: (record) =>
        `/internal_admin/admin_kit/api_roles/${record.id}/permissions`,
      columns: [
        { name: 'name', title: 'Name' },
        { name: 'description', title: 'Description' },
      ],
      add: {
        endpoint: (record) =>
          `/internal_admin/admin_kit/api_roles/${record.id}/add_permission`,
        paramKey: 'api_role_permission',
        field: {
          name: 'permission_id',
          label: 'Permission',
          type: 'typeahead',
          searchEndpoint:
            '/internal_admin/admin_kit/api_roles/permission_search',
        },
      },
      remove: {
        endpoint: (record, row) =>
          `/internal_admin/admin_kit/api_roles/${record.id}/remove_permission/${row.id}`,
      },
    },
  ],

  form: {
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'text' },
    ],
  },
};

export default apiRoleConfig;
